import { ModalityCriteriaForm } from "./tie-break-criteria-post-form";

export class LinkModalityCriteriaForm {
    modalidadeCriterios: ModalityCriteriaForm[] = [];

    constructor(modalidadeCriterios?: ModalityCriteriaForm[]) {
        if (modalidadeCriterios) {
            this.modalidadeCriterios = modalidadeCriterios;
        }
    }

    public static of(list: ModalityCriteriaForm[]): LinkModalityCriteriaForm {
        return new LinkModalityCriteriaForm(list);
    }
}
